import { render, staticRenderFns } from "./search-goods.vue?vue&type=template&id=609ddb2c&scoped=true"
import script from "./search-goods.vue?vue&type=script&lang=js"
export * from "./search-goods.vue?vue&type=script&lang=js"
import style0 from "./search-goods.vue?vue&type=style&index=0&id=609ddb2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ddb2c",
  null
  
)

export default component.exports